module.exports = __webpack_public_path__ + "img/newsletter-page-image-mobile.dcd1f7fa.jpg";